import { render, staticRenderFns } from "./AttendeesSelector.vue?vue&type=template&id=535b0916&scoped=true&"
import script from "./AttendeesSelector.vue?vue&type=script&lang=js&"
export * from "./AttendeesSelector.vue?vue&type=script&lang=js&"
import style0 from "./AttendeesSelector.vue?vue&type=style&index=0&id=535b0916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b0916",
  null
  
)

export default component.exports